import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { withTooltip } from 'components';
import { OptionType } from 'components/CustomSelect/types';
import WaterfallSearchableCellSelect from 'pages/Waterfall/components/WaterfallSearchableCellSelect';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';
import { CaptableListProps } from './CaptableList.props';

const CaptableList = ({ cell, ...restProps }: CaptableListProps) => {
  const { onCommit, onRevert, childrenCapTables } = restProps;
  const { capTableList } = useWaterfallContext();
  const options = useMemo(() => {
    const tmpOptions: OptionType[] = [];

    if (capTableList && !isEmpty(capTableList)) {
      capTableList.forEach(capTable => {
        tmpOptions.push({
          label: capTable.name ?? '',
          value: capTable.id?.toString() ?? '',
        });
      });
      childrenCapTables.forEach(childCapTable => {
        tmpOptions.push({
          label: childCapTable.name ?? '',
          value: childCapTable.id?.toString() ?? '',
        });
      });
    }

    return tmpOptions;
  }, [capTableList, childrenCapTables]);

  return (
    <WaterfallSearchableCellSelect
      cell={cell}
      emptyMessage="No cap tables found"
      id="captable-list"
      itemLabelPlural="cap tables"
      itemLabelSingular="cap table"
      onCommit={onCommit}
      onRevert={onRevert}
      options={options}
      searchPlaceholder="Find a Cap Table"
    />
  );
};

export default withTooltip(CaptableList);
